<template>
  <div class="btn btn-primary flex-fill" @click.stop="store.saveJourney(journey)">
    <div v-if="journey.refreshToken in savedJourneys">
      <i class="icon icon-trash-fill"></i> Löschen
    </div>
    <div v-else><i class="icon icon-bookmark-plus"></i> Merken</div>
  </div>
</template>

<script setup lang="ts">
import type { Journey } from '~/types/fptfTypes'
import { useMainStore } from '~/stores/main'
import { storeToRefs } from 'pinia'

const store = useMainStore()
const { savedJourneys } = storeToRefs(store)

defineProps<{
  journey: Journey
}>()
</script>
